import React from 'react';
import styled, { css } from 'styled-components';
import { Colors } from 'planoplan-ui-kit/core/colors';
import { TABLET_TEXT_WIDTH, LAPTOP_TEXT_WIDTH, FULLHD_TEXT_WIDTH } from '@constants/params';
import { marginLevel, Points, common } from '@styles';
import { textSize } from '@styles';

export const ListItem = ({ number = '1', as = 'div', html = '', theme = 'primary', children }) => {
  return (
    <Container as={as}>
      <Number theme={theme}>{number}</Number>
      {html ? <Content dangerouslySetInnerHTML={{ __html: html }} /> : <Content>{children}</Content>}
    </Container>
  );
};

export const styles = {
  container: css`
    display: flex;
    flex-wrap: nowrap;
    ${textSize('list_header')};
    ${marginLevel('top', 'whisper')};
    color: ${Colors.main_gray};

    @media ${Points.tablet_portrait} {
      width: ${TABLET_TEXT_WIDTH};
      margin-left: auto;
      margin-right: auto;
    }

    @media ${Points.laptop} {
      width: ${LAPTOP_TEXT_WIDTH};
    }

    @media ${Points.fullhd} {
      width: ${FULLHD_TEXT_WIDTH};
    }

    &:last-child {
      margin-bottom: 0;
    }
  `,
  number: css`
    width: 36px;
    height: 36px;
    background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' width='36' height='36' viewBox='0 0 36 36' fill='none'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M0 18C9.94112 18 18 9.94131 18 0C18 9.94131 26.0589 18 36 18C26.0589 18 18 26.0587 18 36C18 26.0587 9.94112 18 0 18Z' fill='%23F2E9E2'/%3e%3c/svg%3e");
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 8px;
    flex-shrink: 0;
    font-size: 11px;
    line-height: 1;

    @media ${Points.tablet_portrait} {
      width: 48px;
      height: 48px;
      margin-right: 10px;
      font-size: 12px;
      line-height: 1.25;
    }

    @media ${Points.laptop} {
      font-size: 14px;
    }

    @media ${Points.fullhd} {
      width: 52px;
      height: 52px;
      margin-right: 15px;
    }
  `,
  content: css`
    width: 100%;

    .visually-hidden,
    strong {
      display: block;
      ${textSize('subtitle')};
      font-weight: 400;
      color: ${Colors.main_dark};
      margin-bottom: 8px;

      &:not(:only-child) {
        margin-bottom: 8px;
      }
    }

    p {
      ${textSize('article')};
      margin-bottom: 20px;
      font-weight: 300;

      &:last-child {
        margin-bottom: 0;
      }
    }

    p > strong {
      display: inline;
      font-weight: 500;
      ${textSize('article')};
    }

    a {
      ${common('a')};
    }

    figure:not(.column) {
      position: relative;
      width: 89vw;
      left: calc((-100vw + 600px) / 2);
    }

    @media ${Points.laptop} {
      padding-top: 5px;

      figure:not(.column) {
        left: -218px;
      }
    }

    @media ${Points.fullhd} {
      padding-top: 6px;

      figure:not(.column) {
        left: -255px;
      }
    }
  `,
};

const Container = styled.div`
  ${styles.container};
`;

const Number = styled.div`
  ${styles.number};
  ${({ theme }) => styles[`number_theme_${theme}`]};
`;

const Content = styled.div`
  ${styles.content};
`;
